import type {ReactElement} from 'react';
import React from 'react';
import type {OnBrandItemClickedCallback} from '@Components/font-selector-panel/font-selector.types';
import BrandFonts from '@Components/editor-brands/components/brand-fonts';
import type {BrandFont} from '@Components/editor-brands/editor-brands.types';
import {BrandAssetName} from '@Components/editor-brands/editor-brands.types';
import EditorBrands from '@Components/editor-brands';
import styles from './fonts-brand-section.module.scss';
import {trackHalloweenBrandKitUsageIfApplicable} from '@Libraries/brands-library';

interface FontsBrandSectionProps {
  onBrandItemClicked?: OnBrandItemClickedCallback;
  showSmallDropdownForBrands?: boolean;

  onAddBrandAsset(): void;

  hasSmallPadding?: boolean;
  showDividerAfterBrandsSection?: boolean;
}

export function FontsBrandSection({
  hasSmallPadding = false,
  onBrandItemClicked = (): void => {},
  showSmallDropdownForBrands = false,
  showDividerAfterBrandsSection = true,
  ...props
}: FontsBrandSectionProps): ReactElement<any> {
  const onFontItemClicked = (_event: React.MouseEvent, brandFont: BrandFont): void => {
    trackHalloweenBrandKitUsageIfApplicable();
    onBrandItemClicked(brandFont);
  };

  return (
    <div className={styles.container}>
      <EditorBrands
        isSmallSection
        className={`spacing-p-b-6 ${hasSmallPadding ? 'spacing-p-t-1' : 'spacing-p-t-3'}`}
        brandAsset={BrandAssetName.FONTS}
        onAddBrandAsset={(): void => {
          props.onAddBrandAsset();
        }}
        showSmallDropdownHeader={showSmallDropdownForBrands}
      >
        <BrandFonts onFontItemClicked={onFontItemClicked} />
      </EditorBrands>
      {showDividerAfterBrandsSection ? <div className={styles.divider} /> : null}
    </div>
  );
}
